import config from "./config";
import appStyles from "./appStyles";
const utils = {
    config,
    appStyles
}
export default utils;